// NL UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Appartementen en hotels',
  'site.currency': 'Valuta',
  'site.language': 'Taal',
  'site.currencySelector': 'Valutaselectie',
  'site.languageSelector': 'Taalselectie',
  'site.menu': 'Menu',
  'site.signIn': 'Inloggen',
  'site.signOut': 'Uitloggen',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Menu openen',
  'site.footer.copyright': 'Alle rechten voorbehouden.',
  'site.footer.manageBooking': 'Beheer je boeking',
  'site.footer.terms': 'Algemene voorwaarden',
  'site.footer.privacy': 'Privacybeleid',
  'site.trust.bestPrice': 'Laagsteprijsgarantie',
  'site.trust.bestPriceDesc': 'De beste tarieven.',
  'site.trust.flexibleBooking': 'Flexibel boeken',
  'site.trust.flexibleBookingDesc': 'Makkelijk wijzigen & annuleren.',
  'site.trust.securePayments': 'Veilige betalingen',
  'site.trust.securePaymentsDesc': 'Vertrouwd & veilig afrekenen.',
  'site.trust.localSupport': 'Lokale ondersteuning',
  'site.trust.localSupportDesc': 'Wij helpen je altijd.',
  'home.heroTitle': 'Vind je perfecte verblijf',
  'home.inAustralia': 'in Australië',
  'home.heroSubtitle': 'Appartementen en hotels voor elke soort verblijf',
  'home.errorLoading': 'Accommodaties konden niet worden geladen.',
  'home.noPropertiesTitle': 'Er zijn momenteel geen accommodaties beschikbaar.',
  'home.noPropertiesDescription':
    'Probeer een bestemming te zoeken om beschikbare verblijven te verkennen.',
  'home.exploreStays': 'Verblijven verkennen',
  'home.property': 'accommodatie',
  'home.property_one': 'accommodatie',
  'home.property_other': 'accommodaties',
  'home.properties': 'accommodaties',
  'home.foundInAustralia': 'gevonden in Australië',
  'search.errorLoading': 'Beschikbaarheid kon niet worden geladen. Probeer het opnieuw.',
  'search.noResults': 'Geen accommodaties voldoen aan je zoekcriteria.',
  'search.mapFollow': 'Zoeken terwijl ik de kaart verplaats',
  'search.chooseLocationTitle': 'Kies een locatie',
  'search.chooseLocationDescription':
    'Selecteer een bestemming voordat je beschikbare verblijven zoekt.',
  'search.chooseDatesTitle': 'Kies je datums',
  'search.pastCheckIn': 'Check-in kan niet in het verleden liggen.',
  'search.checkOutAfterCheckIn': 'Check-out moet na check-in liggen.',
  'search.property': 'accommodatie',
  'search.property_one': 'accommodatie',
  'search.property_other': 'accommodaties',
  'search.properties': 'accommodaties',
  'search.found': 'gevonden',
  'widget.where': 'Waar',
  'widget.location': 'Locatie',
  'widget.checkInOut': 'Inchecken / uitchecken',
  'widget.guests': 'Gasten',
  'widget.rooms': 'Kamers',
  'widget.promoCode': 'Promocode',
  'widget.promoPlaceholderCompact': 'Code toevoegen (optioneel)',
  'widget.promoPlaceholder': 'Optioneel',
  'widget.search': 'Zoeken',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Volwassene',
  'widget.adults': 'Volwassenen',
  'widget.child': 'Kind',
  'widget.children': 'Kinderen',
  'widget.decreaseAdults': 'Volwassenen verminderen',
  'widget.increaseAdults': 'Volwassenen vermeerderen',
  'widget.decreaseChildren': 'Kinderen verminderen',
  'widget.increaseChildren': 'Kinderen vermeerderen',
  'widget.room': 'Kamer',
  'widget.adultOption': '{count} volwassenen',
  'widget.adultOption_one': '{count} volwassene',
  'widget.adultOption_other': '{count} volwassenen',
  'widget.childOption': '{count} kinderen',
  'widget.childOption_one': '{count} kind',
  'widget.childOption_other': '{count} kinderen',
  'widget.roomOption': '{count} kamers',
  'widget.roomOption_one': '{count} kamer',
  'widget.roomOption_other': '{count} kamers',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Locaties konden niet worden geladen. Probeer het opnieuw.',
  'widget.searchAria': 'Beschikbaarheid zoeken',
  'widget.dateErrorRequired': 'Selecteer zowel een check-in- als check-outdatum.',
  'widget.dateErrorPast': 'Check-in kan niet in het verleden liggen.',
  'widget.dateErrorRange': 'Check-out moet na check-in liggen.',
  'widget.dateRange.placeholder': 'Selecteer check-in- en check-outdatum',
  'widget.dateRange.selectCheckout': 'Selecteer check-out',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Check-in / check-out datumbereik',
  'widget.dateRange.previousMonth': 'Vorige maand',
  'widget.dateRange.nextMonth': 'Volgende maand',
  'widget.dateRange.selectCheckIn': 'Selecteer check-in datum',
  'widget.dateRange.selectCheckOut': 'Selecteer check-out datum',
  'widget.dateRange.resetToday': 'Reset naar vandaag',
  'widget.dateRange.done': 'Klaar',
  'property.heroAlt': 'Accommodatie hero',
  'property.fallbackName': 'Geselecteerde accommodatie door {site}',
  'property.chooseRoom': 'Kies je kamer',
  'property.filterBy': 'Filter op:',
  'property.filterAll': 'Alle kamers',
  'property.filterStudios': "Studio's",
  'property.filter1Bed': '1 Slaapkamer',
  'property.filter2Bed': '2 Slaapkamers',
  'property.filterApartments': 'Appartementen',
  'property.sortBy': 'Sorteer op:',
  'property.sortRecommended': 'Aanbevolen',
  'property.sortPriceLow': 'Prijs: laag naar hoog',
  'property.sortPriceHigh': 'Prijs: hoog naar laag',
  'property.errorLoading': 'Beschikbaarheid kon niet worden geladen. Probeer het opnieuw.',
  'property.noRooms': 'Geen kamers beschikbaar',
  'property.noRoomsDescription': 'Probeer andere datums of bezetting.',
  'property.totalForNights': 'Totaal voor {nights} nachten',
  'property.perNight': 'per nacht',
  'property.night': 'nacht',
  'property.night_one': 'nacht',
  'property.night_other': 'nachten',
  'property.nights': 'nachten',
  'property.freeCancellation': 'Gratis annuleren',
  'property.selectRoom': 'Kamer selecteren',
  'property.selected': 'Geselecteerd',
  'property.continue': 'Doorgaan',
  'property.previousPhoto': 'Vorige foto',
  'property.nextPhoto': 'Volgende foto',
  'property.addToWishlist': 'Toevoegen aan verlanglijst',
  'property.popularChoice': 'Populaire keuze',
  'property.showMore': 'Meer tonen',
  'property.showLess': 'Minder tonen',
  'property.maxOccupancy': 'Max. bezetting:',
  'property.size': 'Grootte:',
  'property.bedType': 'Bedtype:',
  'property.roomAmenities': 'Kamervoorzieningen',
  'property.showMoreAmenities': '+{count} meer',
  'property.guests': 'Gasten',
  'property.adults': 'Volwassenen',
  'property.children': 'Kinderen',
  'property.onlyRoomsLeft': 'Nog maar {count} kamers over',
  'property.onlyRoomsLeft_one': 'Nog maar {count} kamer over',
  'property.onlyRoomsLeft_other': 'Nog maar {count} kamers over',
  'property.lastBookedMinutes': 'Laatst geboekt {count} minuten geleden',
  'property.lastBookedMinutes_one': 'Laatst geboekt {count} minuut geleden',
  'property.lastBookedMinutes_other': 'Laatst geboekt {count} minuten geleden',
  'property.lastBookedHours': 'Laatst geboekt {count} uur geleden',
  'property.lastBookedHours_one': 'Laatst geboekt {count} uur geleden',
  'property.lastBookedHours_other': 'Laatst geboekt {count} uur geleden',
  'property.lastBookedDays': 'Laatst geboekt {count} dagen geleden',
  'property.lastBookedDays_one': 'Laatst geboekt {count} dag geleden',
  'property.lastBookedDays_other': 'Laatst geboekt {count} dagen geleden',
  'property.checkInTime': 'Inchecken {time}',
  'property.checkOutTime': 'Uitchecken {time}',
  'property.compare': 'Vergelijken',
  'property.taxesIncluded': 'per nacht inclusief belastingen & toeslagen',
  'property.chooseRate': 'Kies je tarief',
  'property.yourSelection': 'Je selectie',
  'property.aboutRoom': 'Over deze kamer',
  'property.roomDetails': 'Kamerdetails',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Terug naar kamers',
  'property.standardRate': 'Standaardtarief',
  'property.noPromotion': 'Geen promotie beschikbaar voor dit tarief.',
  'property.youSave': 'Je bespaart ({percent}% korting) - {amount}',
  'property.inclusions': 'Inbegrepen:',
  'property.viewAllPhotos': "Alle foto's bekijken",
  'property.seeOnMap': 'Bekijk op kaart',
  'room.perNight': 'nacht',
  'room.sleeps': 'Slaapplaatsen',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'beschikbaar',
  'room.select': 'Selecteren',
  'room.selected': 'Geselecteerd',
  'card.viewAvailability': 'Beschikbaarheid bekijken',
  'card.from': 'Vanaf',
  'card.night': 'nacht',
  'card.checkAvailability': 'Beschikbaarheid controleren',
  'card.saveToFavourites': 'Opslaan in favorieten',
  'card.ratingExcellent': 'Uitstekend',
  'card.ratingVeryGood': 'Zeer goed',
  'card.ratingGood': 'Goed',
  'card.ratingGuest': 'Gastbeoordeling',
  'guest.stepChooseRoom': 'Kamer kiezen',
  'guest.stepGuestDetails': 'Gastgegevens',
  'guest.stepPayment': 'Betaling',
  'guest.stepConfirmation': 'Bevestiging',
  'guest.title': 'Gastgegevens invoeren',
  'guest.subtitle': 'Vul je gegevens in.',
  'guest.firstName': 'Voornaam',
  'guest.lastName': 'Achternaam',
  'guest.email': 'E-mail',
  'guest.emailHint': 'De boekingsbevestiging wordt naar dit e-mailadres verzonden.',
  'guest.country': 'Land',
  'guest.selectCountry': 'Selecteer land',
  'guest.searchCountry': 'Landen zoeken…',
  'guest.loadingCountries': 'Landen laden…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Postcode',
  'guest.phone': 'Telefoonnummer',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Voer telefoonnummer in',
  'guest.address': 'Adres',
  'guest.city': 'Woonplaats',
  'guest.specialRequests': 'Speciale verzoeken (optioneel)',
  'guest.specialRequestsPlaceholder': 'Speciale verzoeken?',
  'guest.termsPrefix': 'Door deze boeking te voltooien, ga ik akkoord met de',
  'guest.terms': 'Algemene voorwaarden',
  'guest.termsAnd': 'en',
  'guest.privacy': 'Privacybeleid',
  'guest.termsSuffix': ', en ik accepteer de boekingsvoorwaarden.',
  'guest.marketingOptOut': 'Ik wil geen marketingberichten ontvangen.',
  'guest.cardVerify':
    'Er wordt een tijdelijke kaartverificatie van 1 {currency} geplaatst. Je wordt nu niet afgeschreven.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Betalen bij aankomst.',
  'guest.noRoomsSelected': 'Geen kamers geselecteerd.',
  'guest.noPropertySelected': 'Geen accommodatie geselecteerd.',
  'guest.paymentStillLoading':
    'Betalingsopties worden nog geladen. Probeer het over enkele ogenblikken opnieuw.',
  'guest.submitProcessing': 'Bezig met verwerken…',
  'guest.submitVerifyCard': 'Kaart verifiëren en boeking bevestigen',
  'guest.submitConfirm': 'Boeking bevestigen',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Betaling',
  'payment.method': 'Betaalmethode',
  'payment.cardDetailsHint':
    'Voer je kaartgegevens veilig hieronder in. Je kaartgegevens worden getokeniseerd en raken onze servers nooit.',
  'payment.loadingForm': 'Betalingsformulier laden…',
  'payment.formUnavailable': 'Betalingsformulier niet beschikbaar.',
  'payment.acceptTerms': 'Ik accepteer de algemene voorwaarden en het annuleringsbeleid.',
  'payment.payNow': 'Nu betalen',
  'payment.processing': 'Bezig met verwerken…',
  'payment.noRoomsSelected': 'Geen kamers geselecteerd.',
  'payment.redirecting': 'Doorverwijzen naar de beveiligde betalingspagina…',
  'payment.notConfigured': 'Quickstream is niet geconfigureerd voor deze accommodatie.',
  'payment.noScript': 'Quickstream-betalingsdienst kon niet worden geladen. Ververs de pagina.',
  'payment.formNotLoaded': 'Betalingsformulier niet geladen. Ververs de pagina.',
  'payment.cardDetails': 'Betaling mislukt. Controleer je kaartgegevens.',
  'payment.tokenizationFailed': 'Kaarttokenisatie mislukt. Probeer het opnieuw.',
  'payment.failed': 'Betaling mislukt.',
  'payment.statusResult': 'Betalingstatus: {status}. Probeer het opnieuw.',
  'confirmation.loading': 'Je boeking laden…',
  'confirmation.notFound':
    'Boeking niet gevonden. Controleer je boekingsreferentie en probeer het opnieuw.',
  'confirmation.errorGeneric':
    'Je boeking kon niet worden bevestigd. Neem contact op met de klantenservice.',
  'confirmation.errorLoadDetails': 'Reserveringsdetails konden niet worden geladen.',
  'confirmation.couldNotComplete': 'We konden je betaling niet voltooien',
  'confirmation.startNew': 'Start een nieuwe boeking',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound':
    'Betalingsessie kon niet worden gevonden. Neem contact op met de klantenservice.',
  'confirmation.paymentStateInvalid':
    'De betaling bevindt zich niet in een geldige status om te voltooien. Begin opnieuw.',
  'confirmation.paymentFailedDeclined':
    'Je betaling kon niet worden voltooid. Controleer je kaartgegevens en probeer het opnieuw, of gebruik een andere betaalmethode.',
  'confirmation.paymentTimeout': 'De betaling duurde te lang. Probeer het opnieuw.',
  'confirmation.paymentGatewayUnavailable':
    'Het betalingssysteem is tijdelijk niet beschikbaar. Probeer het over enkele momenten opnieuw.',
  'confirmation.paymentUnknown': 'Betaling kon niet worden bevestigd: {message}.',
  'confirmation.paymentGenericError':
    'Betaling kon niet worden bevestigd. Probeer het opnieuw of neem contact op met de klantenservice.',
  'summary.title': 'Je boekingsoverzicht',
  'summary.yourBooking': 'Je boekingsoverzicht',
  'summary.noRoomsSelected': 'Nog geen kamers geselecteerd.',
  'summary.checkIn': 'CHECK-IN',
  'summary.checkOut': 'CHECK-OUT',
  'summary.lengthOfStay': 'Verblijfsduur',
  'summary.guests': 'Gasten',
  'summary.nights': '{nights} nachten',
  'summary.nights_one': '{nights} nacht',
  'summary.nights_other': '{nights} nachten',
  'summary.totalForNights': 'Totaal voor {nights} nachten',
  'summary.includingTaxes': 'Inclusief belastingen & toeslagen',
  'summary.discount': 'Bespaar {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Boeking bevestigd!',
  'detail.received': 'Boeking ontvangen',
  'detail.referenceIntro': 'Je boekingsreferentie is',
  'detail.reservationId': 'Reserveringsnummer:',
  'detail.processing':
    'Je boeking wordt verwerkt. Je ontvangt een bevestigingsmail zodra de betaling is bevestigd.',
  'detail.guest': 'Gast',
  'detail.rooms': 'Kamers',
  'detail.night': 'nacht',
  'detail.nights': 'nachten',
  'detail.adult': 'volwassene',
  'detail.adults': 'volwassenen',
  'detail.child': 'kind',
  'detail.infant': 'baby',
  'detail.priceBreakdown': 'Prijsopbouw',
  'detail.subtotal': 'Subtotaal',
  'detail.taxes': 'Belastingen',
  'detail.fees': 'Toeslagen',
  'detail.discounts': 'Kortingen',
  'detail.surcharge': 'Kaarttoeslag',
  'detail.grandTotal': 'Totaal',
  'priceBreakdown.roomSubtotal': 'Subtotaal kamer',
  'priceBreakdown.total': 'Totaal',
  'detail.deposit': 'Aanbetaling',
  'detail.depositDueBy': 'verschuldigd voor',
  'detail.arrival': 'aankomst',
  'detail.specialRequests': 'Speciale verzoeken',
  'detail.backToHome': 'Terug naar home',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Opnieuw proberen',
  'shared.close': 'Sluiten',
  'shared.back': 'Terug',
  'shared.previous': 'Vorige',
  'shared.next': 'Volgende',
  'validation.firstNameRequired': 'Voornaam is verplicht',
  'validation.lastNameRequired': 'Achternaam is verplicht',
  'validation.emailRequired': 'E-mailadres is verplicht',
  'validation.phoneRequired': 'Telefoonnummer is verplicht',
  'validation.addressRequired': 'Adres is verplicht',
  'validation.cityRequired': 'Woonplaats is verplicht',
  'validation.countryRequired': 'Land is verplicht',
  'validation.postalCodeRequired': 'Postcode is verplicht',
  'error.pmsUnavailable':
    'Sorry, deze kamer is niet langer beschikbaar voor je geselecteerde datums. Ga terug en kies andere datums of een andere kamer.',
  'error.pmsSyncError':
    'We konden geen verbinding maken met het accommodatiesysteem. Probeer het over enkele ogenblikken opnieuw.',
  'error.paymentNotConfigured':
    'Betaling is niet geconfigureerd voor deze accommodatie. Kies een andere accommodatie of neem contact op met de klantenservice.',
  'error.paymentStartFailed':
    'Er is iets misgegaan bij het starten van de betaling. Probeer het opnieuw.',
  'error.bookingFailed': 'Boeking mislukt. Probeer het opnieuw.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Boek je verblijf',
  'site.title.suffix': 'Appartementen en hotels',
  'site.title.home': 'Home',
  'site.title.search': 'Zoeken',
  'site.title.property': 'Accommodatie',
  'site.title.room': 'Kamer',
  'site.title.guestDetails': 'Gastgegevens',
  'site.title.payment': 'Betaling',
  'site.title.confirmation': 'Boeking bevestigd',
  'site.title.bookingLookup': 'Boeking zoeken',
  'site.title.bookingDetails': 'Boekingsdetails',
  'site.title.cancellation': 'Boeking annuleren',
  'site.title.reservationDetail': 'Reserveringsdetails',
  'site.title.signIn': 'Inloggen',
  'site.title.signUp': 'Account aanmaken',
  'site.title.notFound': 'Pagina niet gevonden',
  'notFound.title': 'Pagina niet gevonden',
  'notFound.message': 'De pagina die je zoekt bestaat niet.',
  'notFound.backHome': 'Terug naar home',
  'home.heroAlt': 'Skyline van Australische stad',
  'home.featuredProperties': 'Aanbevolen accommodaties',
  'home.popularDestinations': 'Populaire bestemmingen',
  'common.reviews': '{count} recensies',
  'common.reviews_one': '{count} recensie',
  'common.reviews_other': '{count} recensies',
  'common.loading': 'Laden',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'van',
  'common.select': 'Selecteren…',
  'common.search': 'Zoeken…',
  'common.selectLocation': 'Selecteer een locatie',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Geen opties beschikbaar',
  'common.code': 'Code',
  'common.searchCode': 'Code zoeken…',
  'filter.title': 'Filters',
  'filter.price': 'Prijs',
  'filter.priceMinimum': 'Minimum',
  'filter.priceMaximum': 'Maximum',
  'filter.priceMinPlaceholder': '€0',
  'filter.priceMaxPlaceholder': '€500+',
  'filter.propertyType': 'Accommodatietype',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Appartement',
  'filter.propertyType.resort': 'Resort',
  'filter.amenities': 'Voorzieningen',
  'filter.amenity.pool': 'Zwembad',
  'filter.amenity.parking': 'Parkeren',
  'filter.amenity.breakfast': 'Ontbijt inbegrepen',
  'filter.rating': 'Beoordeling',
  'filter.rating.any': 'Elke beoordeling',
  'filter.rating.5': '5 sterren',
  'filter.rating.4': '4 sterren en hoger',
  'filter.rating.3': '3 sterren en hoger',
  'filter.more': 'Meer',
  'filter.more.freeCancellation': 'Gratis annuleren',
  'filter.more.payAtProperty': 'Betalen bij accommodatie',
  'filter.clear': 'Wissen',
  'filter.apply': 'Filters toepassen',
  'card.reviews_one': 'recensie',
  'card.reviews_other': 'recensies',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Leeftijd 0 - 12',
  'auth.orContinueWith': 'Of ga verder met',
  'auth.signIn.title': 'Log in op je account',
  'auth.signIn.subtitle':
    'Welkom terug! Log in om je boekingen te beheren, je verblijven te bekijken en exclusieve aanbiedingen te ontvangen.',
  'auth.email': 'E-mail',
  'auth.emailPlaceholder': 'Voer je e-mailadres in',
  'auth.emailRequired': 'E-mailadres is verplicht.',
  'auth.emailInvalid': 'Voer een geldig e-mailadres in.',
  'auth.password': 'Wachtwoord',
  'auth.passwordPlaceholder': 'Voer je wachtwoord in',
  'auth.createPasswordPlaceholder': 'Maak een wachtwoord',
  'auth.passwordRequired': 'Wachtwoord is verplicht.',
  'auth.passwordMinLength': 'Wachtwoord moet minimaal {min} tekens bevatten.',
  'auth.passwordPattern': 'Wachtwoord moet letters en cijfers bevatten.',
  'auth.passwordHint':
    'Gebruik minimaal {min} tekens met een mix van letters, cijfers en symbolen.',
  'auth.showPassword': 'Wachtwoord tonen',
  'auth.hidePassword': 'Wachtwoord verbergen',
  'auth.keepSignedIn': 'Houd me ingelogd',
  'auth.forgotPassword': 'Wachtwoord vergeten?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Inloggen',
  'auth.signingIn': 'Inloggen...',
  'auth.signInError': 'Inloggen mislukt. Probeer het opnieuw.',
  'auth.googleError': 'Google-inloggen mislukt.',
  'auth.noAccount': 'Nog geen account?',
  'auth.createAccount': 'Account aanmaken',
  'auth.signUp.title': 'Maak je account aan',
  'auth.signUp.subtitle':
    'Word lid van {site} om je boekingen te beheren, je favoriete accommodaties op te slaan en exclusieve aanbiedingen te ontvangen.',
  'auth.firstName': 'Voornaam',
  'auth.firstNamePlaceholder': 'Voer je voornaam in',
  'auth.firstNameRequired': 'Voornaam is verplicht.',
  'auth.lastName': 'Achternaam',
  'auth.lastNamePlaceholder': 'Voer je achternaam in',
  'auth.lastNameRequired': 'Achternaam is verplicht.',
  'auth.mobile': 'Mobiele nummer',
  'auth.mobilePlaceholder': 'Voer je mobiele nummer in',
  'auth.dialingCode': 'Landnummer',
  'auth.mobileRequired': 'Mobiele nummer is verplicht.',
  'auth.mobileInvalid': 'Voer een geldig mobiele nummer in.',
  'auth.confirmPassword': 'Wachtwoord bevestigen',
  'auth.confirmPasswordPlaceholder': 'Bevestig je wachtwoord',
  'auth.termsAgree': 'Ik ga akkoord met de',
  'auth.termsRequired': 'Je moet akkoord gaan met de Algemene voorwaarden en het Privacybeleid.',
  'auth.marketingConsent': 'Ik wil exclusieve aanbiedingen en reisinspiratie ontvangen van {site}',
  'auth.signUpError': 'Account kon niet worden aangemaakt. Probeer het opnieuw.',
  'auth.signUp': 'Aanmelden',
  'auth.creatingAccount': 'Account aanmaken...',
  'auth.createAccountButton': 'Account aanmaken',
  'auth.alreadyHaveAccount': 'Heb je al een account?',
  'auth.passwordMismatch': 'Wachtwoorden komen niet overeen.',
  'pricing.title': 'Prijsopbouw',
  'pricing.noRoomsSelected': 'Geen kamers geselecteerd. Ga terug en selecteer kamers.',
  'pricing.backToAvailability': 'Terug naar beschikbaarheid',
  'pricing.continue': 'Doorgaan naar gastgegevens',
  'property.youSavePercent': 'Je bespaart ({percent}% korting)',
  'property.includingTaxesFees': '(incl. belastingen & toeslagen)',
  'map.zoomIn': 'Inzoomen',
  'map.zoomOut': 'Uitzoomen',
  'map.viewFullMap': 'Bekijk op volledige kaart',
  'booking.progress': 'Boekingsvoortgang',
  'reservationDetail.resetAria': 'Boekingsstatus resetten',
  'bookingLookup.title': 'Zoek je boeking',
  'bookingLookup.description':
    'Voer je boekingsreferentie en e-mailadres in om je reservering te bekijken, wijzigen of annuleren.',
  'bookingLookup.bookingReference': 'Boekingsreferentie',
  'bookingLookup.placeholder': 'bijv. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Opzoeken…',
  'bookingLookup.findBooking': 'Boeking zoeken',
  'bookingLookup.notFound':
    'Boeking niet gevonden. Probeer BK-2026-001, alex.morgan@example.com en Morgan.',
  'cancellation.title': 'Boeking annuleren',
  'cancellation.property': 'Accommodatie',
  'cancellation.details': 'Annuleringsdetails',
  'cancellation.penalty': 'Annuleringskosten',
  'cancellation.refund': 'Terugbetaald bedrag',
  'cancellation.totalPaid': 'Totaal betaald:',
  'cancellation.reasonLabel': 'Reden voor annulering (optioneel)',
  'cancellation.understand': 'Ik begrijp dat deze actie niet ongedaan gemaakt kan worden.',
  'cancellation.cancelledDemo':
    'Je boeking is geannuleerd in deze UI-demo. Terugbetaald bedrag: {{refundAmount}}.',
  'cancellation.confirm': 'Annulering bevestigen',
  'cancellation.notFound': 'Boeking niet gevonden.',
  'bookingDetails.title': 'Boekingsdetails',
  'bookingDetails.notFound': 'Boeking niet gevonden.',
  'bookingDetails.checkIn': 'Check-in:',
  'bookingDetails.checkOut': 'Check-out:',
  'bookingDetails.rooms': 'Kamers',
  'bookingDetails.guest': 'Gast',
  'bookingDetails.freeCancellationUntil': 'Gratis annuleren tot {date}',
  'bookingDetails.total': 'Totaal:',
  'reservationDetail.loading': 'Je boeking laden…',
  'reservationDetail.noReference': 'Geen boekingsreferentie opgegeven.',
  'reservationDetail.loadError': 'Reserveringsdetails konden niet worden geladen.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Locaties laden…',
  'common.couldNotLoadLocations': 'Locaties konden niet worden geladen',
  'common.searchLocationPlaceholder': 'Zoek land, stad of accommodatie',
  'common.collapse': 'Inklappen',
  'common.expand': 'Uitklappen',
  'map.loadingGoogle': 'Google Maps laden…',
  'map.errorGoogle': 'Laden van Google Maps mislukt',
  'map.errorMap': 'Laden van kaart mislukt.',
  'map.greatLocation': 'Geweldige locatie',
  'home.trust.secureBooking': 'Veilig boeken',
  'home.trust.secureBookingDesc': 'Je gegevens zijn veilig bij ons.',
  'home.trust.bestPrice': 'Laagsteprijsgarantie',
  'home.trust.bestPriceDesc': 'Een lagere prijs gevonden? Wij passen onze prijs aan.',
  'home.trust.localSupport': '24/7 ondersteuning',
  'home.trust.localSupportDesc': 'Wij zijn altijd beschikbaar om te helpen.',
  'home.trust.flexibleBooking': 'Flexibele opties',
  'home.trust.flexibleBookingDesc': 'Gratis annulering bij geselecteerde tarieven.',
  'promotion.memberPromo': 'Ledenpromo',
  'promotion.save': 'Bespaar',
  'property.memberRate': 'Ledentarief',
  'property.hideAmenities': 'Voorzieningen verbergen',
  'property.showAllAmenities': 'Alle voorzieningen tonen',
  'property.chooseRatePromo': 'Kies je gewenste tarief - Ledentarieven bieden exclusieve korting!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-{percent}% korting',
  'gallery.imageAlt': '{title} weergave {current} van {total}',
  'gallery.thumbnailAlt': 'Ga naar weergave {current} van {total}',
  'gallery.previewAlt': '{title} voorbeeld',
  'detail.night_one': 'nacht',
  'detail.night_other': 'nachten',
  'detail.adult_one': 'volwassene',
  'detail.adult_other': 'volwassenen',
  'detail.child_one': 'kind',
  'detail.child_other': 'kinderen',
  'detail.infant_one': 'baby',
  'detail.infant_other': "baby's",
} as const;
